import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmailMemberships } from '@mode/shared/schedules/contract';

@Component({
  selector: 'mode-subscriber-list',
  templateUrl: './subscriber-list.component.html',
  styleUrls: ['./subscriber-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriberListComponent {
  @Input() subscribers: EmailMemberships[] = [];
  @Input() authorizedDomains: string[] = [];
  @Input() externalSharingEnabled = false;
  @Output() removeMember = new EventEmitter<EmailMemberships>();

  isExternalDomain(email: string): boolean {
    const emailDomain = email.split('@')[1];
    return emailDomain?.length > 0 && !this.authorizedDomains.includes(emailDomain);
  }
}
